import axios from "axios";

export const brsAxios = axios.create({
  baseURL: process.env.VUE_APP_BRS_LOCAL_API_URL,
  timeout: 120000, //ms
  headers: {
    "Content-Type": "application/json",
  },
});
